<template>
  <div class="header" :style="{ backgroundColor: bgColor }" @touchmove.prevent>
    <svg-btn
      @click="toBack"
      class="icon"
      icon-class="icon-short-hclose"
    ></svg-btn>
    <span class="head">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'NavTopLogin',
  props: {
    title: {
      type: String,
      default: 'Feemoo',
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    toBack() {
      this.$emit('toBack')
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  position: relative;
  .icon {
    position: absolute;
    left: 16px;
    width: 20px;
    height: 20px;
  }
  .head {
    font-weight: 500;
    font-size: 16px;
    color: #2c2c2c;
    line-height: 24px;
  }
}
</style>
